import { Injectable, Inject } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Router } from "@angular/router";
import { UrlRedirection } from '../../models/shared/url-redirection.model';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { CookieService } from 'ngx-cookie-service';

@Injectable()
export class UrlRedirectionService {
  private service = "api/UrlRedirection"; //Controller Name
  constructor(private http: Http, private readonly router: Router, private cookieService: CookieService) { }

  AddUrlRedirection(urlRedirection: UrlRedirection) {
    return this.http
      .post(`${this.service}`, urlRedirection, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  GetUrlRedirections() {
    return this.http.get(`${this.service}/GetUrlRedirections`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetRedirectionTypes() {
    return this.http.get(`${this.service}/GetRedirectionTypes`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }

  GetUrlRedirectionById(id: string) {
    return this.http.get(`${this.service}/GetUrlRedirection?id=` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler)
  }

  DeleteUrlRedirection(id: string) {
    return this.http.delete(`${this.service}/` + id, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  getUrlColumns() {
    return this.http.get(`${this.service}/GetUrlRedirectColumns`, {
      headers: new Headers({
        "Token": this.cookieService.get('Login')
      })
    })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  GetColumnsUploadFile(formData: any) {
    return this.http
      .post(`${this.service}/GetColumnsFromExcelFile`, formData, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) => response.json())
      .catch(this.errorHandler);
  }
  ReadCompleteFile(formData: any) {
    return this.http
      .post(`${this.service}/ReadCompleteFile`, formData, {
        headers: new Headers({
          "Token": this.cookieService.get('Login')
        })
      })
      .map((response: Response) =>
        response.json())
      .catch(this.errorHandler);
  }

  errorHandler(error: Response) {
    
    return Observable.throw(error);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/url-redirection/url-redirection.service.ts